import { render, staticRenderFns } from "./Branch-Report-List.vue?vue&type=template&id=21655752&scoped=true"
import script from "./Branch-Report-List.vue?vue&type=script&lang=js"
export * from "./Branch-Report-List.vue?vue&type=script&lang=js"
import style0 from "./Branch-Report-List.vue?vue&type=style&index=0&id=21655752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21655752",
  null
  
)

export default component.exports